module.exports = __webpack_public_path__ + "static/media/Transit_2x.be6d10d7.jpg";